"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _resizeObserver = require("@juggle/resize-observer");
var _reactResizeDetector = _interopRequireDefault(require("react-resize-detector"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
if (typeof window !== "undefined" && !window.ResizeObserver) {
  window.ResizeObserver = _resizeObserver.ResizeObserver;
}
var _default = _reactResizeDetector.default;
exports.default = _default;